import { lazy, Suspense } from 'react';

// Loaded on demand so the Markets page doesn't grow the main (trading) bundle.
const MarketsView = lazy(() => import('./markets/MarketsView'));

export function MarketsPage() {
  return (
    <Suspense fallback={null}>
      <MarketsView />
    </Suspense>
  );
}
